import { useState, useEffect } from "react";
import { manuelData } from "./manuelData";

const API_KEY = "9bf0e9a9d38a0dfbf5c8992bf51751d0";
const BASE_URL = "https://api.themoviedb.org/3";
const IMG_BASE = "https://image.tmdb.org/t/p/w500";


function App() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [posters, setPosters] = useState([]);

  useEffect(() => {
    const fetchPosters = async () => {
      try {
        const titles = [
          "Interstellar",
          "Breaking Bad",
          "The Pitt",
          "Sinners",
          "Marty Supreme",
          "One Battle After Another",
        ];
        const results = await Promise.all(
          titles.map((title) =>
            fetch(`${BASE_URL}/search/multi?api_key=${API_KEY}&query=${encodeURIComponent(title)}&language=tr-TR`)
              .then((r) => r.json())
              .then((data) => data.results?.[0])
          )
        );
        setPosters(results.filter((item) => item && item.poster_path));
      } catch (e) {
        console.error("Afişler yüklenemedi", e);
      }
    };
    fetchPosters();
  }, []);
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const q = params.get('q');
  if (q) {
    setQuery(q);
  }
}, []);
 const searchTitle = async () => {
  if (!query.trim()) return;
window.history.pushState({}, '', `/?q=${encodeURIComponent(query)}`);
  if (window.gtag) {
    window.gtag('event', 'arama', {
      event_category: 'kullanim',
      event_label: query,
    });
  }
  setLoading(true);
  setError(null);
  setResults(null);

    try {
      const queryLower = query.toLowerCase().trim();
      const manuelEslesmeler = manuelData.filter(
        (item) => item.isim.toLowerCase().includes(queryLower)
      );

      const searchRes = await fetch(
        `${BASE_URL}/search/multi?api_key=${API_KEY}&query=${encodeURIComponent(query)}&language=tr-TR`
      );
      const searchData = await searchRes.json();
      const tmdbSonuclar = searchData.results?.slice(0, 5) || [];

      const tmdbKartlar = await Promise.all(
        tmdbSonuclar.map(async (item) => {
          const type = item.media_type === "tv" ? "tv" : "movie";
          const provRes = await fetch(
            `${BASE_URL}/${type}/${item.id}/watch/providers?api_key=${API_KEY}`
          );
          const provData = await provRes.json();
          const tr = provData.results?.TR;
          return {
            id: item.id,
            title: item.title || item.name,
            year: item.release_date?.slice(0, 4) || item.first_air_date?.slice(0, 4) || "",
            tur: item.media_type === "tv" ? "Dizi" : "Film",
            poster: item.poster_path,
            providers: tr,
            kaynak: "tmdb",
          };
        })
      );

      const manuelKartlar = manuelEslesmeler.map((item) => ({
        id: item.isim + item.yil,
        title: item.isim,
        year: String(item.yil),
        tur: item.tur,
        poster: null,
        manuelPlatform: item.platform,
        kaynak: "manuel",
      }));

      const tumSonuclar = [
        ...tmdbKartlar.filter((k) => k.providers && (k.providers.flatrate || k.providers.rent || k.providers.buy)),
        ...manuelKartlar,
      ];

      if (tumSonuclar.length === 0) {
        setError("Türkiye'de hiçbir platformda bulunamadı.");
      } else {
        setResults(tumSonuclar);
      }
    } catch (e) {
      setError("Bir hata oluştu.");
    }

    setLoading(false);
  };

  const cols = window.innerWidth < 600 ? "repeat(3, 1fr)" : "repeat(6, 1fr)";

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0f0f0f",
      color: "#fff",
      fontFamily: "'Inter', sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 20px",
      position: "relative",
      overflow: "hidden",
    }}>

      <div style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        display: "grid",
        gridTemplateColumns: cols,
        gap: 4,
        zIndex: 0,
        opacity: 0.3,
        transform: "scale(1.05)",
      }}>
        {posters.map((item) => (
          item.poster_path && (
            <img
              key={item.id}
              src={`${IMG_BASE}${item.poster_path}`}
              alt=""
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )
        ))}
      </div>

      <div style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "linear-gradient(to bottom, rgba(15,15,15,0.5), rgba(15,15,15,0.75))",
        zIndex: 1,
      }} />

      <div style={{ width: "100%", maxWidth: 560, position: "relative", zIndex: 2 }}>

        <h1 style={{
          fontSize: 36,
          fontWeight: 700,
          marginBottom: 8,
          letterSpacing: "-0.5px",
        }}>
          Aradığını bul
        </h1>
        <p style={{ color: "#888", marginBottom: 32, fontSize: 15 }}>
          Film ya da dizi adını yaz, hangi platformda olduğunu öğren.
        </p>

        <div style={{ display: "flex", gap: 8 }}>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && searchTitle()}
            placeholder="örn. Breaking Bad, Inception..."
            style={{
              flex: 1,
              padding: "14px 18px",
              fontSize: 15,
              borderRadius: 10,
              border: "1px solid #2a2a2a",
              background: "rgba(26,26,26,0.8)",
              color: "#fff",
              outline: "none",
            }}
          />
          <button
            onClick={searchTitle}
            style={{
              padding: "14px 22px",
              fontSize: 15,
              borderRadius: 10,
              background: "#fff",
              color: "#000",
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            nerde izlerim?
          </button>
        </div>

        {loading && <p style={{ marginTop: 32, color: "#888", fontSize: 14 }}>Aranıyor...</p>}
        {error && <p style={{ marginTop: 32, color: "#ff4444", fontSize: 14 }}>{error}</p>}

        {results && (
          <div style={{ marginTop: 40 }}>
            {results.map((sonuc) => (
              <div key={sonuc.id} style={{
                marginBottom: 32,
                paddingBottom: 32,
                borderBottom: "1px solid #1f1f1f",
              }}>
               <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
  {sonuc.poster && (
    <img
      src={`${IMG_BASE}${sonuc.poster}`}
      alt={sonuc.title}
      style={{ width: 60, borderRadius: 6, objectFit: "cover", flexShrink: 0 }}
    />
  )}
  <div>
    <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 4 }}>
      {sonuc.title}
    </h2>
    <p style={{ color: "#666", fontSize: 13 }}>
      {sonuc.tur} {sonuc.year && `· ${sonuc.year}`}
    </p>
  </div>
</div>

                {sonuc.kaynak === "manuel" ? (
                  <div style={{
  background: "#1a1a1a",
  border: "1px solid #333",
  borderRadius: 10,
  padding: "10px 16px",
  fontSize: 13,
  fontWeight: 600,
  color: "#fff",
  display: "inline-block",
}}>
  {sonuc.manuelPlatform}
</div>
                ) : (
                  <>
                    {sonuc.providers?.flatrate && (
                      <div style={{ marginBottom: 16 }}>
                        <p style={{ color: "#888", fontSize: 11, marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.8px" }}>
                          Abonelikle İzle
                        </p>
                        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                          {sonuc.providers.flatrate.map((p) => (
                            <div key={p.provider_id} style={{ textAlign: "center" }}>
                              <img
                                src={`https://image.tmdb.org/t/p/original${p.logo_path}`}
                                alt={p.provider_name}
                                style={{ width: 48, height: 48, borderRadius: 8 }}
                              />
                              <p style={{ fontSize: 11, marginTop: 6, color: "#aaa" }}>
                                {p.provider_name}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {sonuc.providers?.rent && (
                      <div style={{ marginBottom: 16 }}>
                        <p style={{ color: "#888", fontSize: 11, marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.8px" }}>
                          Kirala
                        </p>
                        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                          {sonuc.providers.rent.map((p) => (
                            <div key={p.provider_id} style={{ textAlign: "center" }}>
                              <img
                                src={`https://image.tmdb.org/t/p/original${p.logo_path}`}
                                alt={p.provider_name}
                                style={{ width: 48, height: 48, borderRadius: 8 }}
                              />
                              <p style={{ fontSize: 11, marginTop: 6, color: "#aaa" }}>
                                {p.provider_name}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        )}

        <div style={{
          marginTop: 60,
          paddingTop: 24,
          borderTop: "1px solid #1f1f1f",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}>
          <span style={{ color: "#444", fontSize: 12, fontWeight: 600 }}>TMDB</span>
          <p style={{ color: "#444", fontSize: 12 }}>
            Bu ürün TMDB API'sini kullanmaktadır ancak TMDB tarafından onaylanmamış veya sertifikalandırılmamıştır.
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;